import Swiper, {Scrollbar} from '../../../../node_modules/swiper/swiper-bundle';

let supportsOrientationChange = 'onorientationchange' in window,
  orientationEvent = supportsOrientationChange ? 'orientationchange' : 'resize';

let Filter = {};

Filter.toggle = function () {
  let openFilter = $('.js-filter-open');
  let closeFilter = $('.js-filter-close');
  let filterContent = $('.js-filter-collapse');

  openFilter.click(function () {
    filterContent.toggleClass('show');
    $('body').toggleClass('filter-is-open');
    if (matchMedia('screen and (max-width: 1023.98px)').matches) {
      window.disableBodyScroll(true, '.js-filter-collapse');
    }
  });

  closeFilter.click(function (e) {
    e.preventDefault();
    filterContent.removeClass('show');
    $('body').removeClass('filter-is-open');
    if (matchMedia('screen and (max-width: 1023.98px)').matches) {
      window.disableBodyScroll(false, '.js-filter-collapse');
    }
  });

  if ($('.product-filter')[0]) {
    window.addEventListener(orientationEvent, function () {
      filterContent.removeClass('show');
      $('body').removeClass('filter-is-open');
      if (matchMedia('screen and (max-width: 1023.98px)').matches) {
        window.disableBodyScroll(false, '.js-filter-collapse');
      }
    }, false);
  }

  $(document).on('click', '.js-filter-collapse .dropdown-menu', function (e) {
    e.stopPropagation();
  });
};

Filter.accordion = function () {
  var toggleAccordion = $('.js-filter-accordion-toggle');

  toggleAccordion.click(function () {
    var thisAccordion = $(this);
    if (thisAccordion.closest('.product-filter-dropdown').hasClass('show')) {
      thisAccordion.closest('.product-filter-dropdown').removeClass('show')
    } else {
      $('.product-filter-dropdown').removeClass('show');
      thisAccordion.closest('.product-filter-dropdown').addClass('show')
    }
  });
};

Filter.dropdownUpdate = function () {
  if ($('.product-filter .filter-container').length === 0) {
    return;
  }

  var $checkSelector = $('.product-filter .custom-dropdown');
  var $checkBox = $('.product-filter .custom-dropdown .check-selector .custom-control-input');

  $checkSelector.each(function () {
    var thisSelector = $(this);
    var count = thisSelector.find('.check-selector .custom-control-input:checked').length;

    if (!thisSelector.hasClass('sort')) {
      if (!count == 0) {
        thisSelector.addClass('has-dash').find('.dropdown-toggle .check-count').text(count);
      }
    }
  });

  $checkBox.change(function () {
    var countCheckedCheck = $(this).closest('.check-selector').find('.custom-control-input:checked').length;

    if (!countCheckedCheck == 0) {
      $(this).closest('.custom-dropdown').addClass('has-dash').find('.dropdown-toggle .check-count').text(countCheckedCheck);
    } else {
      $(this).closest('.custom-dropdown').removeClass('has-dash').find('.dropdown-toggle .check-count').text('');
    }
  });

  var dropdownSelector = $('.product-filter .custom-dropdown .dropdown-menu.sort ul>li');
  dropdownSelector.off('click').on('click', function () {
    dropdownSelector.each(function () {
      $(this).removeClass('selected');
    });

    $(this).addClass('selected');
  });
};

Filter.dropdownUpdate();

Filter.swiper = function() {
    const categoryList = document.querySelector('.js-category-swiper');

    if (!categoryList) return;

    Swiper.use([Scrollbar]);
    const categorySwiper = new Swiper('.js-category-swiper', {
        loop: false,
        slidesPerView: 'auto',
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
    });

    categorySwiper.init();
};

var FilterUpdater = {};

(function ($) {
  Filter.toggle();
  Filter.accordion();
  Filter.swiper();
  var form = $('#silkFilterForm'),
    isSearch = $('body.search').length !== 0;

  //    var initialLoad = true;

  FilterUpdater.update = function (filterProducts) {

    var products = $('.products .product');

    if (filterProducts) {
      products = filterProducts;
    }

    if (form.length === 0 || products.length === 0) {
      return;
    }

    // Hide all filter items
    if (isSearch) {
      form.find('input[type=checkbox]').parents('li').hide();
    } else {
      form.find('input[type=checkbox][name=material],input[type=checkbox][name=color],input[type=checkbox][name=size],input[type=checkbox][name=model],input[type=checkbox][name=heel],input[type=checkbox][name=category]').parents('li').hide();
    }

    // Show only filter items that matches with the products
    $.each(products, function () {
      var product = $(this),
        categories = product.data('category'),
        materials = product.data('material'),
        size = product.data('size'),
        color = product.data('color'),
        model = product.data('model'),
        heel = product.data('heel');

      // Filter categories only in search page
      if (categories) {
      // if (categories && isSearch) {
        $.each(categories.split('|'), function () {
          form.find('input[name=category][value="' + this + '"]').parents('li').show();
        });
      }

      if (materials) {
        $.each(materials.split('|'), function () {
          form.find('input[name=material][value="' + this + '"]').parents('li').show();
        });
      }

      if (size) {
        $.each(size.toString().split('|'), function () {
          form.find('input[name=size][value="' + this + '"]').parents('li').show();
        });
      }

      if (color) {
        $.each(color.split('|'), function () {
          form.find('input[name=color][value="' + this + '"]').parents('li').show();
        });
      }

      if (model) {
        $.each(model.split('|'), function () {
          form.find('input[name=model][value="' + this + '"]').parents('li').show();
        });
      }

      if (heel) {
        $.each(heel.split('|'), function () {
          form.find('input[name=heel][value="' + this + '"]').parents('li').show();
        });
      }
      /*
                  console.log("show");
                  console.log( product.data( 'color' ) );
      */
      form.find('input[name=color][value="' + product.data('color') + '"]').parents('li').show();
      form.find('input[name=size][value="' + product.data('size') + '"]').parents('li').show();
      // form.find( 'input[name=category][data-name="' + product.data( 'category' ) + '"]' ).parents( 'li' ).show();
    });

    // Hide filter group without visible items
    $.each($('ul.check-selector'), function () {
      var list = $(this),
        visibleCount = 0;

      $.each(list.children('li'), function () {
        visibleCount += $(this).css('display') === 'none' ? 0 : 1;
      });

      if (visibleCount < 1) {
        list.parents('.col-lg').hide();
      } else {
        list.parents('.col-lg').show();
      }
    });
  };

  FilterUpdater.update();

  window.FilterUpdater = FilterUpdater;
  window.Filter = Filter;
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/components/filter.js